export const AdvanceRecordsTypes = {
    GET_ADVANCE_RECORDS:'GET_ADVANCE_RECORDS',
}